<template>

  <div class="app-loader" v-if="isLoading">
    <div class="line line-1"></div>
    <div class="line line-2"></div>
    <div class="line line-3"></div>
    <div class="line line-4"></div>
    <div class="line line-5"></div>
  </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "AppLoader",

  computed: {
    ...mapGetters({isLoading: "getIsLoading"})
  }
}
</script>

<style lang="scss" scoped>
div{
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.app-loader{
    position: fixed;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.95);
    height: 100vh;
    width: 100vw;
  }
}

.line{
  background-color: #1976d2;
  width: 7px;
  height: 40px;
  margin: 0 5px;
  border: none;
  animation: size 0.8s infinite linear;
  border-radius: 20px;
}

.line-1{
  animation-delay: 0.60s;
}
.line-2{
  animation-delay: 0.30s;
}
.line-3{
  animation-delay: 0s;
}
.line-4{
  animation-delay: 0.30s;
}
.line-5{
  animation-delay: 0.60s;
}

@keyframes size{
  0%{
    height: 40px;
  }
  25%{
    height: 60px;
  }
  50%{
    height: 90px;
  }
  75%{
    height: 60px;
  }
  100%{
    height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/partials/AppLoader.vue